import { render, staticRenderFns } from "./dialog-visitor.vue?vue&type=template&id=b51906ba&scoped=true&"
import script from "./dialog-visitor.vue?vue&type=script&lang=js&"
export * from "./dialog-visitor.vue?vue&type=script&lang=js&"
import style0 from "./dialog-visitor.vue?vue&type=style&index=0&id=b51906ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51906ba",
  null
  
)

export default component.exports